// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ExecOpsRequest } from "apis/AdminOpsApiCommon";

// 運営ツール: プロンプトのバージョン適用
const AdminOpsPromptApplyApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/ops_prompt_apply";

    const ExecAdminOpsPromptApplyApi = async (groupKey, v) => {
        return ExecOpsRequest(dispatch, { url: url, requestParams: { group_key: groupKey, v: v } });
    };

    return ExecAdminOpsPromptApplyApi;
};

export default AdminOpsPromptApplyApi;
